import mimeDb from 'mime-db';

export const mimeTypeToFileExtension = (mimeType: string) => mimeDb[mimeType]?.extensions?.[0];
